var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input),expression:"input"}],attrs:{"type":"text","placeholder":"e.g ingredients or type of food"},domProps:{"value":(_vm.input)},on:{"input":[function($event){if($event.target.composing)return;_vm.input=$event.target.value},_vm.search]}})
}
var staticRenderFns = []

export { render, staticRenderFns }